module.exports = __webpack_public_path__ + "img/clinician.70596a40.png";